const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  realname:state => state.user.realname,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  tenantId: state=> state.user.tenantId,
  currentDspMonth: state => state.user.currentDspMonth,
  currentSspMonth: state => state.user.currentSspMonth,
  currentReportMonth: state => state.user.currentReportMonth,
}
export default getters
